import useViewport from '../../hooks/useViewport'
import { MobileHeaderModal } from './Header/MobileHeader/MobileHeaderModal'
import { MobileHeader } from './Header/MobileHeader'
import { DesktopHeader } from './Header/DesktopHeader'

const AppHeader = ({ ...restProps }) => {
  const { isMediumOrAbove } = useViewport()

  return (
    <>
      {!isMediumOrAbove && (
        <>
          <MobileHeaderModal />
          <MobileHeader {...restProps} />
        </>
      )}
      {isMediumOrAbove && <DesktopHeader {...restProps} />}
    </>
  )
}

export default AppHeader
